// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toasted-container .toasted .action{font-size:1.4rem;padding:0;margin:5px -7px 5px 12px}.toasted.toasted-primary{font-family:Roboto,\"sans-serif\";padding:10px 20px;min-height:36px;border-radius:3px;font-size:1.4rem;font-weight:400;line-height:1.1em;-webkit-box-shadow:none;box-shadow:none}.toasted.toasted-primary.success{background:#27ae60}.toasted.toasted-primary.error{background:#e04067}.toasted.toasted-primary.info{background:#5b758d}", ""]);
// Exports
module.exports = exports;
